import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {TokenService} from '../services/token.service';
import {Util} from '../utils/Util';

/**
 * Anon guards is used for guarding urls from logged users
 */

@Injectable({
  providedIn: 'root'
})
export class AnonGuard implements CanActivate {
  constructor(private tokenService: TokenService, private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
    : Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.tokenService.isAuthenticated() && !this.tokenService.isTokenExpired()) {
      this.router.navigate([Util.getRedirectionUrl(this.tokenService.getRolesFromToken())]);
      return false;
    } else if (this.tokenService.isAuthenticated() && this.tokenService.isTokenExpired()) {
      this.router.navigate(['logout']);
      return false;
    } else {
      return true;
    }
  }
}
